import axios from "axios";

export const getDenmarkData = async (query) => {
  try {
    query = query.replaceAll("-", " ");
    query = query.replaceAll(".", " ");
    query = query.replaceAll("&", " ");
    query = query.replace(/"/g, "");
    let searchString = "";
    for (const char of query) {
      if (/[æøåÆØÅ]/g.test(char)) {
        searchString += char;
      } else if (/[^a-zA-Z0-9 ]/g.test(char)) {
        searchString += `\\\\${char}`;
      } else {
        searchString += char;
      }
    }
    const params = {
      keyword: searchString,
    };
    let data = await axios.get(
      `${process.env.REACT_APP_COMPANY_LOOKUP_BASE_URL}/searchDenmarkCompany`,
      {
        params,
      }
    );
    if (!data) throw new Error(`Data for Keyword ${query} not found!`, 404);
    data = data.data.hits.hits;
    if (data === "No Search result found") return [];
    let finalData = [];
    for (let item of data) {
      const obj = {
        companyNumber: item["_source"]?.Vrvirksomhed?.cvrNummer,
        companyName:
          item["_source"]?.Vrvirksomhed?.virksomhedMetadata?.nyesteNavn?.navn,
        companyAddress:
          item["_source"]?.Vrvirksomhed?.virksomhedMetadata
            ?.nyesteBeliggenhedsadresse?.vejnavn || null,
      };
      finalData.push(obj);
    }
    return finalData;
  } catch (error) {
    return error;
  }
};
